import { useState, useEffect } from "react";


export const useWindowSize = () => {
    const checkIsNoneMobile = () => { return (window.innerWidth > 768) };
    const checkIsMiniDisplay = () => { return (window.innerWidth < 360) };
    const [isNonMobile, setIsNonMobile] = useState(checkIsNoneMobile());
    const [isMiniDisplay, setIsMiniDisplay] = useState(checkIsMiniDisplay());
    const calcInnerWidth = () => {
        // console.log('isNoneMobile', checkIsNoneMobile());
        // console.log('isMiniDisplay', checkIsMiniDisplay());
        setIsMiniDisplay(checkIsMiniDisplay());
        setIsNonMobile(checkIsNoneMobile());
    };

    useEffect(() => {
        window.addEventListener('resize', calcInnerWidth);
        return () => window.removeEventListener('resize', calcInnerWidth);
    }, []);

    return { isNonMobile, isMiniDisplay };
}
